module.exports = __webpack_public_path__ + "static/media/selectUserDownIcon.6e51904b.svg";